import { Operator } from '@ve/types';
import { IOperatorRepository } from './types';
import OperatorEntity from './OperatorEntity';

const operatorStore: IOperatorRepository = {
    namespaced: true,
    state: {
        operators: [],
    },
    mutations: {
        updatesEntities(state: IOperatorRepository['state'], operators: Operator[] | undefined, imagesDomain: string): void {
            const operatorEntitiesIds = state.operators.map((operator) => operator.id);
            const operatorsWithoutCurrentOperators = operators?.filter((operator) => operatorEntitiesIds.indexOf(operator.id) === -1) || [];
            const operatorsEntity = operatorsWithoutCurrentOperators.map((operator) => new OperatorEntity(operator, imagesDomain));
            state.operators = [...state.operators, ...operatorsEntity];
        },
    },
    getters: {
        getEntities: (state: IOperatorRepository['state']): OperatorEntity[] => state.operators,
    },
};

export default operatorStore;
